import clsx from 'clsx';
import {forwardRef} from 'react';
import {NavVariant} from '../Nav';
import {navCssClassNames} from './navCssClassNames';
import {FixedSideNav, FixedSideNavProps} from './variants/FixedSideNav';
import {SideNav, SideNavProps} from './variants/SideNav';
import {TopNav, TopNavProps} from './variants/TopNav';

export interface NavProps extends TopNavProps, SideNavProps, FixedSideNavProps {
    variant?: NavVariant;
}

export const Nav = forwardRef<HTMLElement, NavProps>(({
    variant = 'top', isContained, hasDivider, className, ...props
}, ref) => {
    const {
        Component, componentProps
    } = ({
        'top': {
            Component: TopNav,
            componentProps: {
                ...props,
                isContained,
                hasDivider
            }
        },
        'side': {
            Component: SideNav,
            componentProps: props
        },
        'fixedSide': {
            Component: FixedSideNav,
            componentProps: props
        }
    } as const)[variant];

    return (
        <Component
            {...componentProps}
            className={clsx(
                className,
                navCssClassNames.root
            )}
            ref={ref}
        />
    );
});

Nav.displayName = 'Nav';
